import { TourStepId } from '../model/types/TourStepId';

export function getStepTarget(id: string): string {
  return `[data-testid="${id}"]`;
}
